import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Users, Clock, MapPin, Heart } from "lucide-react";
import { whyUsReasons, businessInfo, sectionContent } from "@/config/contentConfig";

const reasonIcons = [
  <Users className="w-6 h-6" />,
  <Clock className="w-6 h-6" />,
  <MapPin className="w-6 h-6" />,
  <Heart className="w-6 h-6" />
];

export const WhyUs = () => {

  return (
    <section id="pourquoi" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 gradient-fun text-white border-0">{sectionContent.whyUs.badge}</Badge>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
            <span className="bg-gradient-to-r from-fun to-primary bg-clip-text text-transparent">
              {sectionContent.whyUs.title}
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {sectionContent.whyUs.description}
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:gap-8 mb-16 max-w-7xl mx-auto">
          {whyUsReasons.map((reason, index) => (
            <Card 
              key={index} 
              className="group hover:shadow-card transition-all duration-300 hover:scale-105 border-0 shadow-gentle"
            >
              <CardContent className="p-8 text-center">
                <div className={`w-16 h-16 ${reason.color} rounded-2xl flex items-center justify-center mx-auto mb-6 text-white group-hover:scale-110 transition-transform duration-300`}>
                  {reasonIcons[index]}
                </div>
                <h3 className="text-xl font-display font-semibold mb-4">
                  {reason.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {reason.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-sky rounded-3xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div className="space-y-2">
              <div className="text-4xl md:text-5xl font-display font-bold text-primary">
                {businessInfo.stats.experience}
              </div>
              <div className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
                {businessInfo.stats.experienceLabel}
              </div>
            </div>
            <div className="space-y-2">
              <div className="text-4xl md:text-5xl font-display font-bold text-secondary">
                {businessInfo.stats.events}
              </div>
              <div className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
                {businessInfo.stats.eventsLabel}
              </div>
            </div>
            <div className="space-y-2">
              <div className="text-4xl md:text-5xl font-display font-bold text-fun">
                {businessInfo.stats.satisfaction}
              </div>
              <div className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
                {businessInfo.stats.satisfactionLabel}
              </div>
            </div>
            <div className="space-y-2">
              <div className="text-4xl md:text-5xl font-display font-bold text-accent">
                {businessInfo.stats.priceFrom}
              </div>
              <div className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
                {businessInfo.stats.priceLabel}
              </div>
            </div>
          </div>
        </div>

        {/* Service Areas */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-display font-bold mb-8">
            Point de Retrait
          </h3>
          <div className="flex justify-center">
            <Badge variant="outline" className="px-6 py-3 text-lg">
              <MapPin className="w-5 h-5 mr-3" />
              {businessInfo.location.address.city}
            </Badge>
          </div>
          <p className="mt-4 text-muted-foreground text-center">
            {sectionContent.whyUs.pickupNote}
          </p>
        </div>
      </div>
    </section>
  );
};